import './Header.scss';
import './Header.mobile.scss';
import type { MouseEvent } from 'react';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export const Header = ({ reduced }: { reduced?: true }) => {
  const [burgerVisibility, setBurgerVisibility] = useState(false);
  const navigate = useNavigate();

  function navigateToSection(event: MouseEvent<HTMLAnchorElement>, sectionId: string) {
    event.preventDefault();
    setBurgerVisibility(false);

    if (window.location.pathname !== '/') {
      sessionStorage.setItem('krlScrollTarget', sectionId);
      navigate('/');
      return;
    }

    document.getElementById(sectionId)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
    window.history.replaceState(null, '', `/#${sectionId}`);
  }

  return (
    <header id='header-top-page'>
      <div className='container'>

        {
          !reduced &&
          <div className={`menu-burger ${burgerVisibility ? 'visible' : ''}`}>
            <button>
              <img src={`/assets/images/menu-burger-icon.png`}
                onClick={
                  () => setBurgerVisibility(!burgerVisibility)
                }
              />
            </button>

            <div className='burger-nav'>
              <button>
                <img src={`/assets/images/close-icon.png`}
                  onClick={
                    () => setBurgerVisibility(!burgerVisibility)
                  }
                />
              </button>
              <ul>
                <li>
                  <a onClick={() => alert('Em breve!')}>Loja</a>
                </li>
              <li><a href="/#ourLegacy" onClick={(event) => navigateToSection(event, 'ourLegacy')}>Sobre nós</a></li>
              <li><a href="/#solutions" onClick={(event) => navigateToSection(event, 'solutions')}>Soluções</a></li>
              <li><a href="/#contact" onClick={(event) => navigateToSection(event, 'contact')}>Contato</a></li>
              </ul>
            </div>
          </div>
        }

        <Link to={'/'}>
          <img src="/assets/images/principal-logo.png" className="principal-logo" />
        </Link>
        <button className='client-area'><a href="https://intranet.krlservices.com.br/user/login" target='_blank'>Sou Cliente</a></button>
      </div>

      {
        !reduced &&
        <>
          <nav>
            <ul>
              <li onClick={() => alert('Em breve!')}>Loja</li>
              <li><a href="/#ourLegacy" onClick={(event) => navigateToSection(event, 'ourLegacy')}>Sobre nós</a></li>
              <li><a href="/#solutions" onClick={(event) => navigateToSection(event, 'solutions')}>Soluções</a></li>
              <li><a href="/#contact" onClick={(event) => navigateToSection(event, 'contact')}>Contato</a></li>
            </ul>
          </nav>
          <div className='header-banner reduced'>
            <div className='header-banner-content'>
              <img src='/assets/images/header/header-banner-text.png' />
              <a href="/#solutions" onClick={(event) => navigateToSection(event, 'solutions')}>
                <button>CONHEÇA</button>
              </a>
            </div>
          </div>
        </>
      }

    </header>
  )
}
